import {
	TimelineLite
} from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

export default (() => {
	/**
	 *  navbar animations
	 */

	if ($('.front-page').length > 0) {
		$('.header__menu-logo').css('opacity', '0');
		document.querySelector('.header__menu-items').classList.remove('header__menu-items--right');
	} else if ($('.single-game-page').length > 0) {
		if ($('.hero').hasClass('hero--single-game')) {
			document.querySelector('.header__menu').classList.add('header__menu--white');
		} else {
			document.querySelector('.header__menu').classList.add('header__menu--green');
		}
	} else if ($('.game-main-page').length > 0 || $('.news-page').length > 0) {
		document.querySelector('.header__menu').classList.add('header__menu--green');
	} else if ($('.careers-page').length > 0) {
		document.querySelector('.header__menu').classList.add('header__menu--yellow');
	}

	const controller = new ScrollMagic.Controller();

	new ScrollMagic.Scene({
		triggerElement: '.header',
		triggerHook: '0.7',
		duration: '100%'
	})
		.on('enter', e => {
			if (e.type === 'enter' && e.scrollDirection === 'REVERSE') {
				if ($('.front-page').length > 0) {
					new TimelineLite()
						.to('.header__menu-logo', 1, {
							y: 5,
							opacity: 0,
							onStart: () => {
								document.querySelector('.header__menu').classList.remove('header__menu--white');
								if ($('.fixed-R-top').length > 0 || $('.fixed-R-bottom').length > 0) {
									document.querySelector('.fixed-R-top').classList.remove('white');
									document.querySelector('.fixed-R-bottom').classList.remove('white');
								}
							}
						})
						.to(
							'.header__menu-items',
							1, {
								onStart: () => {
									document
										.querySelector('.header__menu-items')
										.classList.remove('header__menu-items--right');
								}
							},
							'-=1'
						);
				} else {
					new TimelineLite()
						.to('.header__menu-logo', 1, {
							onStart: () => {
								if ($('.fixed-R-top').length > 0 || $('.fixed-R-bottom').length > 0) {
									document.querySelector('.fixed-R-top').classList.remove('white');
									document.querySelector('.fixed-R-bottom').classList.remove('white');
								}
							}
						});
				}
			}
		})
		.on('leave', e => {
			if ($('.fixed-R-top').length > 0 || $('.fixed-R-bottom').length > 0) {
				document.querySelector('.fixed-R-top').classList.add('white');
				document.querySelector('.fixed-R-bottom').classList.add('white');
			}
			if ($('.front-page').length > 0) {
				new TimelineLite()
					.to('.header__menu-items', 1, {
						onStart: () => {
							document
								.querySelector('.header__menu-items')
								.classList.add('header__menu-items--right');
						}
					})
					.fromTo(
						'.header__menu-logo',
						1, {
							x: 5,
							y: 5,
							opacity: 0
						}, {
							x: 0,
							y: 0,
							opacity: 1,
							onStart: () => {
								document.querySelector('.header__menu').classList.add('header__menu--white');
							}
						},
						'-=1'
					);
			}
		})
		.addTo(controller);
})();
